import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed,
  onMounted,
  ref,
  toRefs,
  watch,
  withDefaults,
} from 'vue';
import { DataSource } from '@/common/Autocomplete/useDataSource';


export default /*#__PURE__*/_defineComponent({
  __name: 'Autocomplete',
  props: {
    dataSource: {},
    multiple: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    modelValue: { default: null },
    isIdValue: { type: Boolean },
    filterDataSource: { default: undefined },
    itemValue: { default: 'value' },
    itemText: { default: 'text' },
    label: {},
    rules: { default: undefined },
    load: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    filterFn: { default: undefined },
    clearable: { type: Boolean, default: false },
    errorMessages: { default: () => [] },
    useInput: { type: Boolean, default: true }
  },
  emits: ['update:model-value', 'update:model-value-full', 'loading'],
  setup(__props: any, { emit: emits }) {

const props = __props;





const {
  modelValue,
  dataSource,
  disabled,
  filterDataSource,
  itemValue,
  itemText,
  load,
  rules,
  readonly,
  label,
  errorMessages,
  error,
  clearable,
  filterFn,
} = toRefs(props);

const errorMessage = computed(() => errorMessages.value.join(', '));

const options = ref([]);

const search = ref('');

const filterOptions = ref(options.value || []);

const {
  setSearch, setFilters, data, reload, loading,
} = dataSource.value;

watch(
  () => loading,
  (newStatus) => {
    emits('loading', newStatus);
  },
);

const defaultFilterFn = (val, update) => {
  if (val === '') {
    update(() => {
      filterOptions.value = options.value;
    });
    return;
  }
  update(() => {
    const label = itemText.value;
    const needle = val.toLowerCase();
    // @ts-ignore
    filterOptions.value = options.value.filter(
      (v: any) => v[label]?.toLowerCase().indexOf(needle) > -1,
    );
  });
};

const activeFilter = computed(() => filterFn.value || defaultFilterFn);

watch(
  search,
  (newValue, oldValue) => {
    if (oldValue !== newValue) {
      setSearch(newValue);
    }
  },
  { immediate: true },
);

watch(
  filterDataSource,
  () => {
    setFilters(filterDataSource.value);
  },
  { immediate: true },
);

const changeHandler = (value) => {
  emits('update:model-value', value);

  if (props.isIdValue) {
    emits(
      'update:model-value-full',
      filterOptions.value.find((item) => item[itemValue.value] === value),
    );
  } else {
    emits('update:model-value-full', value);
  }
};

onMounted(() => {
  data.subscribe((data) => {
    options.value = data;
    filterOptions.value = data;
    if (props.isIdValue && modelValue.value) {
      emits(
        'update:model-value-full',
        filterOptions.value.find((item) => item[itemValue.value] === modelValue.value),
      );
    }
  });

  if (load.value) {
    reload();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps(_ctx.$attrs, {
    "use-input": _ctx.useInput,
    "model-value": _unref(modelValue),
    options: filterOptions.value,
    multiple: _ctx.multiple,
    loading: _unref(loading),
    rules: _unref(rules),
    "emit-value": _ctx.isIdValue,
    "map-options": _ctx.isIdValue,
    disable: _unref(disabled),
    "option-label": _unref(itemText),
    "option-value": _unref(itemValue),
    error: _unref(error),
    label: _unref(label),
    clearable: _unref(clearable),
    readonly: _unref(loading) || _unref(readonly),
    autocomplete: "country",
    "error-message": errorMessage.value,
    onFilter: activeFilter.value,
    "onUpdate:modelValue": changeHandler
  }), _createSlots({
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(search.value
            ? _ctx.$t('dangerousPhenomena.dataMissing')
            : _ctx.$t('enterSearch')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 2
  }, [
    (_ctx.$slots.option)
      ? {
          name: "option",
          fn: _withCtx((optionDate) => [
            _renderSlot(_ctx.$slots, "option", { data: optionDate })
          ]),
          key: "0"
        }
      : undefined
  ]), 1040, ["use-input", "model-value", "options", "multiple", "loading", "rules", "emit-value", "map-options", "disable", "option-label", "option-value", "error", "label", "clearable", "readonly", "error-message", "onFilter"]))
}
}

})